import React from 'react';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-duotone-svg-icons';

class CarrierRow extends React.PureComponent {
  renderLogo = (org, editLogoMode) => {
    const { logosList, organizationsToEdit, dispatch } = this.props;
    const selectedLogo = logosList.filter((logo) => logo.id === org.carrier_logo);
    let logoName = '';
    let logoID = '';

    if (selectedLogo.length) {
      logoName = selectedLogo[0].logo_name;
      logoID = selectedLogo[0].id;
    }

    if (editLogoMode === 'individual') {
      const editChanges = organizationsToEdit.filter((o) => o.id === org.id);

      if (editChanges.length) {
        return (
          <Input
            type="select"
            name="select"
            id="select"
            onChange={(e) => {
              if (e.target.value === '') {
                dispatch({
                  type: 'ADD_ORG_TO_EDIT',
                  payload: org,
                  logo_id: 'remove_from_store',
                  display_name: null,
                });
              } else {
                dispatch({
                  type: 'ADD_ORG_TO_EDIT',
                  payload: org,
                  logo_id: e.target.value,
                  display_name: null,
                });
              }
            }}
            disabled={editChanges[0].display_name}
          >
            {logoID ? null : <option value="">{' '}</option>}
            {logosList.map((logo) => (
              <option value={logo.id} selected={logo.id === Number(editChanges[0].logo_id)}>
                {logo.logo_name}
              </option>
            ))}
            {logoID ? <option value="null">Remove Logo</option> : null}
          </Input>
        );
      }

      return (
        <Input
          type="select"
          name="select"
          id="select"
          onChange={(e) => (
            dispatch({
              type: 'ADD_ORG_TO_EDIT',
              payload: org,
              logo_id: e.target.value,
              display_name: null,
            })
          )}
          disabled={org.display_name}
        >
          {logoID ? null : <option value="">{' '}</option>}
          {logosList.map((logo) => (
            <option value={logo.id} selected={logo.id === logoID}>{logo.logo_name}</option>
          ))}
          {logoID ? <option value="null">Remove Logo</option> : null}
        </Input>
      );
    }

    return logoName || '--';
  };

  renderDisplayName = (org, editLogoMode) => {
    const {
      dispatch,
      organizationsToEdit,
      logosList,
      organizationsList,
    } = this.props;

    const selectedOrg = organizationsToEdit.filter((o) => o.id === org.id);

    if (selectedOrg.length) {
      if ((selectedOrg[0].logo_id === undefined || selectedOrg[0].logo_id === null) && editLogoMode === 'individual') {
        return (
          <Input
            onChange={(e) => {
              const storedOrgData = organizationsList.filter((o) => o.id === org.id);

              if (e.target.value === '' && !storedOrgData[0].display_name) {
                dispatch({
                  type: 'ADD_ORG_TO_EDIT',
                  payload: org,
                  display_name: 'remove_from_store',
                  logo_id: null,
                });
              } else {
                dispatch({
                  type: 'ADD_ORG_TO_EDIT',
                  payload: org,
                  display_name: e.target.value,
                  logo_id: null,
                });
              }
            }}
            value={selectedOrg.length ? selectedOrg[0].display_name : org.display_name}
          />
        );
      }
      if ((typeof selectedOrg[0].logo_id === 'string') && selectedOrg[0].logo_id !== '') {
        return '--';
      }
    }

    const selectedLogo = logosList.filter((logo) => logo.id === org.carrier_logo);
    if (selectedLogo.length) {
      return '--';
    }

    if (editLogoMode === 'individual') {
      return (
        <Input
          onChange={(e) => (
            dispatch({
              type: 'ADD_ORG_TO_EDIT',
              payload: org,
              display_name: e.target.value,
              logo_id: null,
            })
          )}
          value={selectedOrg.length ? selectedOrg[0].display_name : org.display_name}
        />
      );
    }
    return org.display_name || '--';
  };

  render() {
    const {
      organization,
      editLogoMode,
      dispatch,
      organizationsToEdit,
    } = this.props;
    const beingEdited = organizationsToEdit.filter((org) => org.id === organization.id).length;

    return (
      <tr style={{ height: '35px' }}>
        {
          editLogoMode === 'multiple'
            ? (
              <td className="text-center p-0 ps-1">
                <input
                  className="form-control"
                  type="checkbox"
                  id={organization.id}
                  onChange={(e) => dispatch({
                    type: 'HANDLE_ORG_EDIT_CHECKBOX',
                    payload: {
                      checked: e.target.checked,
                      organization,
                    },
                  })}
                  checked={beingEdited}
                />
              </td>
            )
            : <td className="text-center p-0 ps-1" />
        }
        <td className="text-capitalize">
          {organization.organization_name}
          {beingEdited ? <FontAwesomeIcon icon={faPencil} size="sm" className="ms-2" /> : null}
        </td>
        <td className="text-capitalize">
          {this.renderLogo(organization, editLogoMode)}
        </td>
        <td className="text-capitalize">
          {this.renderDisplayName(organization, editLogoMode)}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (store) => ({
  editLogoMode: store.modals.editLogoMode,
  logosList: store.logos.logosList,
  organizationsToEdit: store.logos.organizationsToEdit,
  organizationsList: store.logos.organizationsList,
});

export default connect(mapStateToProps)(CarrierRow);
